import { Type } from 'class-transformer';
import { KeyValueResultDto } from '../../../_models/key-value-result-dto';
import { VendorContractRawDto } from './vendor-contract-raw-dto';

export class VendorContractEditorResultDto {
    @Type(() => VendorContractRawDto)
    vendorContract: VendorContractRawDto;
    @Type(() => KeyValueResultDto)
    contractTypes: KeyValueResultDto[];
    @Type(() => KeyValueResultDto)
    contractTerms: KeyValueResultDto[];
    @Type(() => KeyValueResultDto)
    autoRenewFrequencies: KeyValueResultDto[];
    @Type(() => KeyValueResultDto)
    serviceCategories: KeyValueResultDto[];
    @Type(() => KeyValueResultDto)
    serviceFrequencies: KeyValueResultDto[];
    contractsHelpKey: string;
}
